import { AdKind } from 'constants/ads';
import DirectAdvertisement from '../DirectAdvertisement';
import RtbAdvertisement from '../RtbAdvertisement';
import { jsx as _jsx } from "react/jsx-runtime";

const AdContent = _ref => {
  let {
    id,
    placementConfig,
    isManuallyRefreshed,
    isManuallyRendered,
    onAdRender
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "ad-content",
    children: placementConfig.kind === AdKind.Rtb ? /*#__PURE__*/_jsx(RtbAdvertisement, {
      id: id,
      config: placementConfig,
      isManuallyRendered: isManuallyRendered,
      isManuallyRefreshed: isManuallyRefreshed,
      onAdRender: onAdRender
    }) : /*#__PURE__*/_jsx(DirectAdvertisement, {
      id: id,
      config: placementConfig,
      onAdRender: onAdRender
    })
  });
};

export default AdContent;